"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var analytics_layer_1 = require("@pmi/analytics-layer");
var factory_1 = require("../../LinkEventCreators/factory");
var utils_1 = require("../../utils");
var linkInteraction = function (event, context) {
    if (event.eventType !== analytics_layer_1.EventTypes.LinkInteraction || context.isHandled) {
        return;
    }
    var mainEventData = (0, factory_1.getCreator)(event.eventName)(event);
    (0, utils_1.pushEvent)(mainEventData);
    context.isHandled = true;
};
exports.default = linkInteraction;
